module.exports = {"ru":{"nextBtn":"Далее","prevBtn":"Назад","doneBtn":"Готово","skipBtn":"Пропустить","closeTooltip":"Закрыть"},"en":{"nextBtn":"Next","prevBtn":"Previous","doneBtn":"Done","skipBtn":"Skip","closeTooltip":"Close"}}


//////////////////
// WEBPACK FOOTER
// ./temp/components/tour/text.yaml
// module id = 90
// module chunks = 0